// Übersetzungen [Suomi, English] der Bot-Gegner. Namen in der Schreibweise der jeweiligen Sprache.
export const BOTS: Record<string, [string, string]> = {
  'Mensch': ['Ihminen', 'Human'],
  'Einsteiger {n}': ['Aloittelija {n}', 'Beginner {n}'],
  'Ab 1350 Elo geeicht über Stockfishs Elo-Begrenzung (UCI_Elo), Richtwerte. Darunter vier Einsteiger-Stufen ohne gemessene Elo; echte Elo-Werte ab 800 bietet „Großmeister“.':
    ['1350 Elosta alkaen kalibroitu Stockfishin Elo-rajoituksella (UCI_Elo), suuntaa-antava. Sen alla neljä aloittelijatasoa ilman mitattua Eloa; todelliset Elo-arvot 800:sta alkaen tarjoaa ”Suurmestari”.',
     'From 1350 Elo calibrated via Stockfish\'s Elo limit (UCI_Elo), approximate. Below that four beginner levels without measured Elo; real Elo values from 800 are offered by “Grandmaster”.'],
  'Großmeister': ['Suurmestari', 'Grandmaster'],
  'Vorbild': ['Esikuva', 'Model'],
  'Berühmte Spieler': ['Kuuluisat pelaajat', 'Famous players'],
  'Stile': ['Tyylit', 'Styles'],
  '{n}-Stil': ['{n}-tyyli', '{n} style'],
  '{n} denkt …': ['{n} miettii …', '{n} is thinking …'],
  'Partie gegen {n}': ['Peli vastaan {n}', 'Game against {n}'],
  'Der Gegner hat keinen Zug geliefert.': ['Vastustaja ei antanut siirtoa.', 'The opponent returned no move.'],
  'Zieht wie Menschen dieser Stärke, mit ihren typischen Fehlern (Maia, Universität Toronto). Ein Zug ohne Vorausrechnen.':
    ['Siirtää kuin tämän tasoiset ihmiset, tyypillisine virheineen (Maia, Toronton yliopisto). Siirto ilman laskentaa.',
     'Moves like humans of this strength, with their typical mistakes (Maia, University of Toronto). One move without calculation.'],
  'Der Stil ist über Bewertung und Eröffnungsbuch nachempfunden (Rodent IV), keine Kopie des Spielers.':
    ['Tyyli on jäljitelty arvioinnin ja avauskirjan avulla (Rodent IV), ei kopio pelaajasta.',
     'The style is approximated through evaluation and opening book (Rodent IV), not a copy of the player.'],
  'Aljechin': ['Aljehin', 'Alekhine'],
  'Botwinnik': ['Botvinnik', 'Botvinnik'],
  'Karpow': ['Karpov', 'Karpov'],
  'Kasparow': ['Kasparov', 'Kasparov'],
  'Kortschnoi': ['Kortšnoi', 'Korchnoi'],
  'Petrosjan': ['Petrosjan', 'Petrosian'],
  'Spasski': ['Spasski', 'Spassky'],
  'Topalow': ['Topalov', 'Topalov'],
  'Verteidiger': ['Puolustaja', 'Defender'],
  'Dynamiker': ['Dynaamikko', 'Dynamic'],
  'Bauernopferer': ['Sotilasuhraaja', 'Pawn sacrificer'],
  'Hitzkopf': ['Kuumapää', 'Hothead'],
  'Würger': ['Kuristaja', 'Strangler'],
  'Abtauscher': ['Vaihtaja', 'Swapper'],
  // Meldungen des Servers
  'Bot antwortet nicht': ['Botti ei vastaa', 'Bot is not responding'],
  'Bot abgestürzt': ['Botti kaatui', 'Bot crashed'],
  'Maia nicht installiert': ['Maiaa ei ole asennettu', 'Maia is not installed'],
  'Rodent nicht installiert': ['Rodentia ei ole asennettu', 'Rodent is not installed'],
};
